"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBulkNotificationStatusUpdate = void 0;
const notification_center_models_1 = require("@forto-dev/notification-center-models");
const lodash_es_1 = require("lodash-es");
const react_1 = require("react");
const updateNotificationStatus_1 = require("../api/updateNotificationStatus");
const useBulkNotificationStatusUpdate = () => {
    const [itemsData, setItemsData] = (0, react_1.useState)([]);
    const updateNotificationStatus = (0, updateNotificationStatus_1.useUpdateNotificationStatus)();
    const updateNotifications = (elements) => {
        const visibleItems = (0, lodash_es_1.compact)(elements.map((elem) => {
            if (elem) {
                return elem.dataset['id'];
            }
            return null;
        }));
        setItemsData(visibleItems);
    };
    (0, react_1.useEffect)(() => {
        const collectAndUpdateStatus = () => {
            if (itemsData.length) {
                updateNotificationStatus.mutate({ ids: itemsData, status: notification_center_models_1.UserNotificationStatus.UnRead });
                setItemsData([]);
            }
        };
        collectAndUpdateStatus();
    }, [itemsData, updateNotificationStatus]);
    return updateNotifications;
};
exports.useBulkNotificationStatusUpdate = useBulkNotificationStatusUpdate;
//# sourceMappingURL=useBulkNotificationStatusUpdate.js.map